import { createFileRoute, Outlet } from '@tanstack/react-router'
import { KeyGate } from '@/crypto/KeyGate'
import { Ficha } from '@/features/pacientes/Ficha'
import { usePatientCrumbs } from '@/nav'

/**
 * A ficha do paciente: nome, abas e a aba aberta. Tudo nela é clínico, então
 * a chave fica aqui, uma vez, e não em cada aba.
 */
export const Route = createFileRoute('/_app/app/p/$id')({
  staticData: { crumb: { useCrumbs: usePatientCrumbs } },
  component: function FichaDoPaciente() {
    const { id } = Route.useParams()
    return (
      <KeyGate>
        <Ficha patientId={id}>
          <Outlet />
        </Ficha>
      </KeyGate>
    )
  },
})
